export const profileData = {
  name: "Kevin Huang",
  tagline: "cs + math + stats @ purdue",
  about: "Software engineer interested in systems performance, infrastructure, and machine learning. I also play competitive Tetris.",
  now: "Working on a 0→1 proactive cost regression detection framework at Databricks.",
  skills: "Python · JavaScript · TypeScript · C · C++ · Swift · Objective-C · SQL · PyTorch · TensorFlow · React · Next.js · Node.js · Flask · Metal · Docker · Git · PostgreSQL · Redis",
  coursework: [
    "Statistical Machine Learning (CS 57800)",
    "Natural Language Processing (CS 57700)",
    "Operating Systems (CS 35400)",
    "Data Mining & Machine Learning (CS 37300)",
    "Intro to Artificial Intelligence (CS 47100)",
    "Probability (STAT 41600)",
    "Statistical Theory (STAT 41700)",
    "Applied Regression Analysis (STAT 51200)",
    "Analysis of Algorithms (CS 38100)",
    "Linear Programming & Optimization (MA 42100)"
  ],
  experience: [
    {
      role: "Software Engineer Intern",
      company: "Apple (Vision Products Group)",
      period: "May 2025 - Aug 2025",
      desc: "Engineered core spatial safety boundary mechanisms for Apple Vision Pro integrated with visionOS. Developed prototyping tools, a Swift CLI for benchmarking, and a Metal API data processing pipeline.",
    },
    {
      role: "Software Engineer Intern",
      company: "Polyspawn AI",
      period: "May 2024 - Aug 2024",
      desc: "Designed full-stack React labeling app integrated with Google Drive. Refined Stable Diffusion model for 2D animation and implemented transformer frame-consistency mechanisms in PyTorch Lightning.",
    },
    {
      role: "Machine Learning Developer",
      company: "TE Connectivity",
      period: "Jan 2024 - May 2024",
      desc: "Patented two ML solutions (action segmentation & glove detection) saving $170K annually. Fine-tuned YOLOv9 model and developed a React video labeling platform.",
    },
  ],
  projects: [
    {
      title: "Dialed",
      desc: "Climbing app with mobile route visualization. Features an Expo (React Native) app, a Django REST API, and a custom YOLOv8/v9 computer vision pipeline for automated climbing hold segmentation.",
      link: "https://github.com/CS407-Team14/dialed",
      tag: "react native · django · yolo · pytorch",
    },
    {
      title: "X Parks the Spot",
      desc: "C2C parking marketplace platform. Built Next.js SSR, Redux, and Flask/PostgreSQL backend with microservices for Redis auth, S3 storage, and Stripe.",
      link: "https://github.com/inner-LMNt/x-parks-the-spot",
      tag: "next.js · flask · postgres · stripe",
    },
    {
      title: "Boiler Schedulings",
      desc: "Course scheduling app for Purdue students with RAG-based AI recommendations and professor insights.",
      link: "https://github.com/orgs/Boiler-Schedulings/repositories",
      tag: "react · rag · firebase",
    },
    {
      title: "Purdue Mosaic",
      desc: "Responsive collaborative pixel art whiteboard supporting 100+ concurrent users with low latency.",
      link: "https://github.com/inner-LMNt/PurdueMosaic",
      tag: "react · socket.io · node.js",
    },
    {
      title: "Housing Camper",
      desc: "Automated housing availability monitoring system using custom web scraping and Discord notifications.",
      link: "https://github.com/inner-LMNt/housing-camper",
      tag: "node.js · discord api · scraping",
    },
    {
      title: "Pdetris",
      desc: "Tetris in Processing. An ode to something I'm pretty good at.",
      link: "https://github.com/inner-LMNt/Pdetris",
      tag: "java · processing",
    },
  ],
  links: [
    { label: "Email", href: "mailto:huan2005@purdue.edu" },
    { label: "GitHub", href: "https://github.com/inner-LMNt" },
    { label: "LinkedIn", href: "https://www.linkedin.com/in/kevin-t-huang/" },
    { label: "TETR.IO", href: "https://ch.tetr.io/u/lmn_t" },
    { label: "Jstris", href: "https://jstris.jezevec10.com/u/fleuron" },
  ],
};
